import { useContext } from "react";
import { useQuery } from "react-query";
import AppContext from "../appContext";

import * as api from "../services";

function useScheduler(props) {
  const {
    app: {
      client: { id: contextId },
      project: { id: projectId },
      sessionId,
    },
  } = useContext(AppContext);
  const clientId = props?.id ?? contextId;
  const {
    data: scheduler,
    isLoading: isSchedulerLoading,
    refetch: refetchScheduler,
  } = useQuery({
    queryKey: ["scheduler", clientId, projectId, sessionId],
    queryFn: () => api.getBeepSchedule({ clientId, projectId, sessionId }),
    enabled: clientId !== -1,
  });
  return { scheduler, isSchedulerLoading, refetchScheduler };
}

export default useScheduler;
